import { getConfiguration } from '@chr/common-web-ui-configuration'
import { getAxiosInstance, getUserProfileAsync } from '@chr/online-shared-microsite-core'
import { AppConfig } from '../../react-app-env'
import { VisibilityUserSettings, VisibilityUserSettingsQueryResult } from "../constants/online.homepagegateway.api"

export const getVisibilityUserSetting = async (): Promise<VisibilityUserSettings> => {
  const [axiosInstance, config, userProfile] = await Promise.all([
    getAxiosInstance(),
    getConfiguration<AppConfig>(),
    getUserProfileAsync(),
  ])

  if (!userProfile?.userId) {
    throw new Error('User ID is missing')
  }

  const endpoint = `${config.gatewayApiUri}/visibilityUserSettings/${userProfile.userId.toString()}`
  const response = await axiosInstance.get<VisibilityUserSettingsQueryResult>(endpoint);
  return response.data.visibilityUserSettings;
}